module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-SemiBold.dac78b0f.woff";